import { ReactNode, useCallback, useEffect, useState } from 'react'
import DataTable, { TableColumn } from "react-data-table-component";
import { LogLeadTemp } from '../../../interfaces/LogLeadTemp';
import { useDataTableStore } from '../../../stores/DataTableStore';
import useLogLeadTempStore from '../../../stores/LogLeadTemp';
import { Link, useParams } from 'react-router-dom';
import { useSettingsStore } from '../../../stores/SettingsStore';
import { usePipelineStore } from '../../../stores/PipelineStore';
import { useGeneralStore } from '../../../stores/General';
import { useIntl } from 'react-intl';
import { AddLog } from '../../../components/Pipelines/Logs/AddLog';
import { Pipeline } from '../../../interfaces/Pipeline';
import { RecentChatHistoryPipeline } from '../../../interfaces/Chat/RecentChatHistory';
import BtnActionSelectPipeline from '../../../components/Pipelines/BtnActionAddPipelineDropdown/BtnActionSelectPipeline';
import BadgeTooltip from '../../../components/General/BadgeTooltip';
import { isColorDarkFromHex } from '../../../functions/general';
import PreviewAttachmentTermin from '../../../components/Pipelines/DetailTermin/PreviewAttachmentTermin';
import { ExpandableElement } from '../../../components/General/ExpandableElement';
import { IconButton } from '@mui/material';
import { Menu } from '@mui/material';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { MenuItem } from '@mui/material';
import DeleteLogLeadTemp from './LogLeadTemp/DeleteLogLeadTemp';
import useModalEffect from '../../../hooks/useModalEffect';
import DetailTerminLogTemp from './LogLeadTemp/DetailTerminLogTemp';
import { DetailProductPipeline } from '../../../components/Pipelines/DetailProductPipeline';
import { bulkUploadLogLeadTemp, validateDataForUpload, BulkUploadProgress, BulkUploadResult } from '../../../api/LogLeadTempCRUD';
import { calculateChunkSize, formatFileSize } from '../../../functions/formDataUtils';
import BulkUploadProgressModal from '../../../components/Pipelines/Logs/BulkUploadProgressModal';
import Swal from 'sweetalert2';
import useAccessToken from '../../../hooks/AccessToken';
import { useSearchFilter } from '../../../hooks/useSearchFilter';
import ImageModal from '../../../components/Pipelines/Logs/ImageModal';
import { Modal } from 'bootstrap';
import useClearModalBackdropElement from '../../../hooks/useClearModalBackdropElement';

const MasterLogLeadTable = () => {
    const { templatePipelineId } = useParams()
    const { setIsShowFormLogLead } = useGeneralStore()
    const { settings } = useSettingsStore()
    const { selectMultiPipeline } = usePipelineStore()
    const intl = useIntl()
    const [showModalSelectedPipeline, setShowModalSelectedPipeline] = useState(false)
    const [showModalAddLog, setShowModalAddLog] = useState(false)
    const [showModalEditLog, setShowModalEditLog] = useState(false)
    const [previewFiles, setPreviewFiles] = useState<File | File[]>([]);
    const [showAttachmentModal, setShowAttachmentModal] = useState(false);
    const { selectedPipelineLogTemp } = usePipelineStore()
    const { getLogLeadTempByTemplatePipelineId, removeLogLeadTempByIdLog, updateLogLeadTempKeyError, removeLogLeadTempByTemplatePipelineId } = useLogLeadTempStore()
    const [openMenuId, setOpenMenuId] = useState<string | null>(null);
    const [showModalDeleteLogLeadTemp, setShowModalDeleteLogLeadTemp] = useState(false)
    const [showModalDetailLogProduct, setShowModalDetailLogProduct] = useState(false)
    const [detailLogLeadTemp, setDetailLogLeadTemp] = useState<LogLeadTemp | null>(null)
    const [showModalDetailLogTermin, setShowModalDetailLogTermin] = useState(false)
    const [lead, setLead] = useState<Pipeline | RecentChatHistoryPipeline | null>(null)
    const [isUploading, setIsUploading] = useState(false)
    const [uploadProgress, setUploadProgress] = useState<BulkUploadProgress | null>(null)
    const [showProgressModal, setShowProgressModal] = useState(false)
    const { tablesData } = useDataTableStore()
    const token = useAccessToken()
    const [dataResults, setDataResults] = useState<BulkUploadResult | null>(null)
    const [isDeleting, setIsDeleting] = useState(false)
    const [modalImage, setModalImage] = useState({ show: false, url: '', title: '' });

    const logLeadTempData = getLogLeadTempByTemplatePipelineId(templatePipelineId || '')

    const {
        searchText,
        filteredData: filteredLogLeadTempData,
        handleSearchChange,
        isSearching
    } = useSearchFilter(logLeadTempData, {
        searchFields: ['pipelineName', 'progressName', 'description'],
        debounceMs: 300
    })

    let actions: ReactNode[] = []

    const handlePreviewClick = (files: File | File[]) => {
        setPreviewFiles(files);
        setShowAttachmentModal(true);
    };

    const handleClosePreview = () => {
        setShowAttachmentModal(false);
        setPreviewFiles([]);
    };

    const handleClick = (menuId: string) => {
        setOpenMenuId(menuId);
    };
    const handleClose = () => {
        setOpenMenuId(null);
    };

    useEffect(() => {
        if (showModalEditLog) {
            const pipeline = tablesData['pipelines'].find((item) => item.id === detailLogLeadTemp?.leadId)
            setLead(pipeline as Pipeline | RecentChatHistoryPipeline)
        }
    }, [showModalEditLog, detailLogLeadTemp, tablesData])


    const columns: TableColumn<LogLeadTemp>[] = [
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.ACTION' }),
            center: true,
            allowOverflow: true,
            width: '70px',
            id: 'fixedLeft',
            cell: (row) => {
                return (
                    <>
                        <IconButton
                            aria-label={`more-${row.id}`}
                            id={`menu-anchor-${row.id}`}
                            onClick={() => handleClick(row.id)}
                        >
                            <MoreVertIcon />
                        </IconButton>

                        <Menu
                            id={`menu-${row.id}`}
                            anchorEl={document.getElementById(`menu-anchor-${row.id}`)}
                            open={openMenuId === row.id}
                            onClose={handleClose}
                            disableScrollLock={true}
                        >
                            <MenuItem onClick={() => {
                                handleClose();
                                setDetailLogLeadTemp(row)
                                setShowModalEditLog(true)
                            }}>
                                <i className="fas fa-edit fs-4 me-4"></i>
                                <span>{intl.formatMessage({ id: 'FORM.ACTION.UPDATE' }, { title: 'Log' })}</span>
                            </MenuItem>

                            <MenuItem onClick={() => {
                                handleClose();
                                setShowModalDeleteLogLeadTemp(true)
                                setDetailLogLeadTemp(row)
                            }}>
                                <i className="fas fa-trash fs-4 me-4"></i>
                                <span>{intl.formatMessage({ id: 'FORM.ACTION.DELETE' })}</span>
                            </MenuItem>

                            {
                                row.termins.length > 0 && (
                                    <MenuItem onClick={() => {
                                        handleClose();
                                        setDetailLogLeadTemp(row)
                                        setShowModalDetailLogTermin(true)
                                    }}>
                                        <i className="fas fa-eye fs-4 me-3"></i>
                                        <span>{intl.formatMessage({ id: 'FORM.ACTION.DETAIL_TERMIN' })}</span>
                                    </MenuItem>
                                )
                            }

                            {
                                row.leadProducts.length > 0 && (
                                    <MenuItem onClick={() => {
                                        handleClose();
                                        setDetailLogLeadTemp(row)
                                        setShowModalDetailLogProduct(true)
                                    }}>
                                        <i className="pi pi-info-circle fs-4 me-3"></i>
                                        <span>{intl.formatMessage({ id: 'FORM.ACTION.PRODUCTS_DETAIL' })}</span>
                                    </MenuItem>
                                )
                            }
                        </Menu>
                    </>
                )
            },
        },
        {
            name: 'Pipeline',
            width: '400px',
            selector: (row) => row.pipelineName,
            cell: (row) => {
                if (row.keyError) {
                    return (
                        <div className="d-flex align-items-center">
                            <span>{row.pipelineName}</span>
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-error-${row.id}`}>
                                        <div className="text-start">
                                            <strong>Error:</strong><br />
                                            {row.keyError}
                                        </div>
                                    </Tooltip>
                                }
                            >
                                <span className="badge badge-light-danger ms-2 cursor-pointer">
                                    <i className="fas fa-exclamation-triangle"></i>
                                </span>
                            </OverlayTrigger>
                        </div>
                    )
                }

                return <span>{row.pipelineName}</span>
            }
        },
        {
            name: 'Progress',
            width: '200px',
            selector: (row) => row.progressName,
            cell: (row) => {
                const progressName = row.progressName;
                const subProgressName = row.subProgressName;
                const progressColor = row.leadProgressColor;

                const badgeStyle = progressColor
                    ? { backgroundColor: progressColor, color: isColorDarkFromHex(progressColor) ? "white" : "black" }
                    : { backgroundColor: "transparent", }; // Default when no color

                const badgeContent = subProgressName
                    ? `${progressName} (${subProgressName})`
                    : progressName;

                return (
                    <BadgeTooltip tooltipText={badgeContent} badgeClass={`my-2 mx-1 ${progressColor ? '' : 'badge-light-info'}`} style={badgeStyle}>
                        {badgeContent}
                    </BadgeTooltip>
                );
            }
        },
        {
            name: 'Description',
            width: '350px',
            selector: (row) => row.description,
            cell: (row) => {
                let descriptionContent = [];

                if (row.description) {
                    descriptionContent.push(<div key={`description-${row.id}`} dangerouslySetInnerHTML={{ __html: row.description }} />);
                }

                return (
                    <ExpandableElement
                        key={`description-${row.id}`}
                        content={
                            <div className="custom-field-log">
                                {descriptionContent}
                            </div>
                        }
                        maxHeight={100}
                    />
                );
            }
        },
        {
            name: 'Attachment',
            width: '200px',
            cell: (row) => {
                const attachment = row.attachments as File | File[];
                if (!attachment || (Array.isArray(attachment) && attachment.length === 0)) {
                    return '-'
                }

                return (
                    <span
                        role="button"
                        onClick={() => handlePreviewClick(attachment)}
                        className="text-primary cursor-pointer d-flex align-items-center"
                        style={{ cursor: 'pointer' }}
                    >
                        <i className="fas fa-file-invoice fs-5 me-2"></i>
                    </span>
                );
            }
        },
    ]

    const renderButtonAddLogTemp = () => {
        return (
            <button
                type='button'
                className='btn btn-primary'
                onClick={() => setShowModalSelectedPipeline(true)}
            >
                <i className="fas fa-plus"></i> {intl.formatMessage({ id: "FORM.ACTION.ADD" })} Log
            </button>
        )
    }

    actions.push(
        renderButtonAddLogTemp()
    )

    const handleDeleteAllData = async () => {
        const result = await Swal.fire({
            title: intl.formatMessage({ id: "FORM.LABEL.CONFIRM_DELETING" }),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: intl.formatMessage({ id: "FORM.ACTION.YES" }),
            cancelButtonText: intl.formatMessage({ id: "FORM.ACTION.CANCEL" }),
            reverseButtons: true,
            heightAuto: false
        })

        if (result.isConfirmed) {
            setIsDeleting(true)
            await removeLogLeadTempByTemplatePipelineId(templatePipelineId || '')
            setIsDeleting(false)
            Swal.fire({
                icon: 'success',
                title: intl.formatMessage({ id: "FORM.LABEL.SUCCESS" }),
                text: intl.formatMessage({ id: "FORM.LABEL.DATA_DELETED_SUCCESSFULLY" }, { title: 'Log' }),
                heightAuto: false
            })
        }
    }

    const handleSaveAllData = async () => {
        if (!templatePipelineId) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Template Pipeline ID tidak ditemukan',
                heightAuto: false
            })
            return
        }

        if (isUploading) {
            return
        }

        try {
            const dataToUpload = logLeadTempData

            if (dataToUpload.length === 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Peringatan',
                    text: 'Tidak ada data untuk disimpan',
                    heightAuto: false
                })
                return
            }

            const validation = validateDataForUpload(dataToUpload)
            if (!validation.isValid) {
                Swal.fire({
                    icon: 'error',
                    title: 'Validasi Gagal',
                    html: `<div class="text-start"><strong>Errors:</strong><br/>${validation.errors.map(error => `• ${error}`).join('<br/>')}</div>`,
                    heightAuto: false
                })
                return
            }

            // Calculate total size and show confirmation
            const totalSize = calculateChunkSize(dataToUpload)
            const formattedSize = formatFileSize(totalSize)

            const confirmResult = await Swal.fire({
                title: intl.formatMessage({ id: 'FORM.VALIDATION.CONFIRM_UPLOAD' }),
                html: `
                    <div class="text-center">
                        <ul class="list-unstyled">
                            <li><i class="fas fa-database text-primary me-2"></i>${intl.formatMessage({ id: 'FORM.VALIDATION.TOTAL_LOG_LEAD' }, { title: selectMultiPipeline.name })}: ${dataToUpload.length}</li>
                        </ul>
                    </div>
                `,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: intl.formatMessage({ id: 'FORM.ACTION.YES' }),
                cancelButtonText: intl.formatMessage({ id: 'FORM.ACTION.CANCEL' }),
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                heightAuto: false
            })

            if (!confirmResult.isConfirmed) {
                return
            }

            // Start upload process
            setIsUploading(true)
            setShowProgressModal(true)
            setUploadProgress({
                totalChunks: 0,
                currentChunk: 0,
                totalItems: dataToUpload.length,
                processedItems: 0,
                currentChunkSize: '',
                totalSize: formattedSize,
                percentage: 0,
                isCompleted: false,
                errors: []
            })

            // Perform bulk upload
            const result = await bulkUploadLogLeadTemp(
                templatePipelineId,
                dataToUpload,
                token,
                (progress) => {
                    setUploadProgress(progress)
                }
            )

            // Handle upload completion
            if (result.success) {
                setDataResults(result)
                if (result.dataSuccess.length > 0) {
                    for (const data of result.dataSuccess) {
                        await removeLogLeadTempByIdLog(data.id)
                    }
                }

                if (result.dataError.length > 0) {
                    for (const data of result.dataError) {
                        const updateResult = await updateLogLeadTempKeyError(data.id, data.error)
                        if (!updateResult) {
                            console.warn(`Failed to update error status for log ID: ${data.id}`)
                        }
                    }
                }
            } else {
                const message = result.totalProcessed > 0
                    ? `${result.totalProcessed} data berhasil diupload, ${result.totalErrors} gagal`
                    : 'Upload gagal. Silakan coba lagi.'

                Swal.fire({
                    icon: result.totalProcessed > 0 ? 'warning' : 'error',
                    title: result.totalProcessed > 0 ? 'Upload Sebagian Berhasil' : 'Upload Gagal',
                    text: message,
                    showConfirmButton: true,
                    heightAuto: false
                })
            }

        } catch (error) {
            console.error('Error in handleSaveAllData:', error)

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `Terjadi kesalahan: ${error instanceof Error ? error.message : 'Unknown error'}`,
                heightAuto: false
            })
        } finally {
            setIsUploading(false)
            // Don't close progress modal immediately, let user see the final result
        }
    }

    const handleImageClick = useCallback((e: MouseEvent) => {
        const target = e.target as HTMLElement;
        if (target.classList.contains('image-link')) {
            e.preventDefault();
            const imageUrl = target.getAttribute('data-image-url');
            const imageIndex = target.getAttribute('data-image-index');
            if (imageUrl && imageIndex) {
                setModalImage({ show: true, url: imageUrl, title: `Gambar ${imageIndex}` });
            }
        }
    }, []);

    useEffect(() => {
        document.addEventListener('click', handleImageClick);
        return () => {
            document.removeEventListener('click', handleImageClick);
        };
    }, [handleImageClick]);

    useModalEffect({
        showModal: showModalDeleteLogLeadTemp,
        setShowModal: setShowModalDeleteLogLeadTemp,
        modalId: `delete-log-lead-temp-modal-${detailLogLeadTemp?.id}`
    })

    useModalEffect({
        showModal: showModalDetailLogTermin,
        setShowModal: setShowModalDetailLogTermin,
        modalId: `detail-termin-log-temp-modal-${detailLogLeadTemp?.id}`
    })

    useModalEffect({
        showModal: showModalDetailLogProduct,
        setShowModal: setShowModalDetailLogProduct,
        modalId: `detail-product-pipeline-modal-${detailLogLeadTemp?.id}`
    })

    useModalEffect({
        showModal: showModalAddLog,
        setShowModal: setShowModalAddLog,
        modalId: `tambah-log-modal`
    })

    useClearModalBackdropElement({ showModal: showModalEditLog })

    useEffect(() => {
        if (showModalEditLog && lead && Object.keys(lead).length > 0) {
            const timer = setTimeout(() => {
                const modalElement = document.getElementById('tambah-log-modal');
                console.log('Delayed modal check - Modal element found:', modalElement);

                if (modalElement) {
                    const modalInstance = new Modal(modalElement);
                    modalInstance.show();

                    const handleModalHide = () => {
                        setShowModalEditLog(false);
                        document.body.classList.remove('modal-open');
                    };

                    modalElement.addEventListener('hidden.bs.modal', handleModalHide);

                    return () => {
                        modalElement.removeEventListener('hidden.bs.modal', handleModalHide);
                        modalInstance.dispose();
                    };
                } else {
                    console.error('Modal element with ID "tambah-log-modal" not found after delay');
                }
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [showModalEditLog, lead])

    return (
        <>
            <div className="row justify-content-between mb-3">
                <div className="col-lg-4 col-sm-3 col-xl-5" style={{ alignSelf: "center" }}>
                    <ol className="text-muted breadcrumb fs-6 fw-bold">
                        <li className="text-muted breadcrumb-item">{settings.pipeline_title}</li>
                        <li className="breadcrumb-item pe-3">
                            <Link to={`/pipelines/${templatePipelineId}`} className='text-muted text-hover-primary' onClick={() => {
                                setIsShowFormLogLead(false)
                            }}>
                                {selectMultiPipeline.name}
                            </Link>
                        </li>
                        <li className="text-dark breadcrumb-item">Log Lead</li>
                    </ol>
                </div>
            </div >

            <div className="card rounded" style={{ overflow: 'revert' }}>
                <div className="card-header border-0">
                    <div className="card-title">
                        <div className="d-flex align-items-center position-relative my-1 skeleton-button" id="divSearch">
                            <span className="svg-icon svg-icon-1 position-absolute ms-6 mt-3">
                                <i className="bi bi-search"></i>
                            </span>
                            <input
                                type="search"
                                data-kt-lists-table-filter="search"
                                className={`form-control form-control-solid w-210px ps-15 skeleton mt-3 ${isSearching ? 'border-primary' : ''}`}
                                placeholder={intl.formatMessage({ id: 'MASTERS.DATATABLE.SEARCH.PLACEHOLDER' })}
                                id="inputSearch"
                                value={searchText}
                                onChange={(e) => handleSearchChange(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="card-toolbar align-self-center">
                        {
                            actions && actions.map((action, index) => (
                                <div key={index} className="me-5 me-md-3">
                                    {action}
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div className="card-body pt-0">
                    <DataTable
                        key={`datatable-${filteredLogLeadTempData.length}-${JSON.stringify(filteredLogLeadTempData.map(item => item.id))}`}
                        columns={columns}
                        data={filteredLogLeadTempData}
                        pagination
                        paginationRowsPerPageOptions={[10, 20, 40, 60, 80]}
                    />
                </div>
            </div>
            <div className='d-flex justify-content-start mt-3 gap-2'>
                {
                    logLeadTempData.length > 0 && (
                        <button
                            type='button'
                            className='btn btn-danger'
                            onClick={handleDeleteAllData}
                            disabled={isDeleting || logLeadTempData.length === 0}
                        >
                            {isDeleting ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Deleting...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-trash me-2"></i>
                                    {intl.formatMessage({ id: "FORM.LABEL.GENERAL_CLEAR" }, { title: 'Log' })}
                                </>
                            )}
                        </button>
                    )
                }
                <button
                    type='button'
                    className='btn btn-primary'
                    onClick={handleSaveAllData}
                    disabled={isUploading || logLeadTempData.length === 0}
                >
                    {isUploading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Uploading...
                        </>
                    ) : (
                        <>
                            <i className="fas fa-save me-2"></i>
                            {intl.formatMessage({ id: "FORM.LABEL.SAVE_ALL_DATA" })}
                        </>
                    )}
                </button>
                {logLeadTempData.length > 0 && !isUploading && (
                    <div className="ms-3 align-self-center">
                        <small className="text-muted">
                            {logLeadTempData.length} item(s) siap untuk diupload
                            {(() => {
                                const errorItems = logLeadTempData.filter(item => item.keyError)
                                if (errorItems.length > 0) {
                                    return (
                                        <span className="text-danger ms-2">
                                            ({errorItems.length} dengan error)
                                        </span>
                                    )
                                }
                                return null
                            })()}
                        </small>
                    </div>
                )}
            </div>

            {
                showModalAddLog && (
                    <AddLog
                        lead={selectedPipelineLogTemp as Pipeline | RecentChatHistoryPipeline}
                        showModal={showModalAddLog}
                        setShowModal={setShowModalAddLog}
                        typeLog='log-lead-temp'
                    />
                )
            }

            {
                showModalEditLog && lead && Object.keys(lead).length > 0 && (
                    <AddLog
                        lead={lead as Pipeline | RecentChatHistoryPipeline}
                        showModal={showModalEditLog}
                        setShowModal={setShowModalEditLog}
                        typeLog='log-lead-temp'
                        typeAction='edit'
                        logLeadTemp={detailLogLeadTemp as LogLeadTemp}
                    />
                )
            }

            {
                showModalSelectedPipeline && (
                    <BtnActionSelectPipeline
                        showModal={showModalSelectedPipeline}
                        handleModalClose={() => setShowModalSelectedPipeline(false)}
                        setShowModalAddLog={setShowModalAddLog}
                    />
                )
            }

            {
                showAttachmentModal && (
                    <PreviewAttachmentTermin
                        files={previewFiles}
                        onClose={handleClosePreview}
                    />
                )
            }

            {
                showModalDeleteLogLeadTemp && (
                    <DeleteLogLeadTemp
                        logLeadTemp={detailLogLeadTemp as LogLeadTemp}
                    />
                )
            }

            {
                showModalDetailLogTermin && detailLogLeadTemp && (
                    <DetailTerminLogTemp logLeadTemp={detailLogLeadTemp as LogLeadTemp} />
                )
            }

            {
                showModalDetailLogProduct && detailLogLeadTemp && (
                    <DetailProductPipeline pipeline={detailLogLeadTemp as LogLeadTemp} type='log-lead-temp' />
                )
            }

            {/* Bulk Upload Progress Modal */}
            <BulkUploadProgressModal
                show={showProgressModal}
                progress={uploadProgress}
                onClose={() => {
                    setShowProgressModal(false)
                    setUploadProgress(null)
                }}
                dataResults={dataResults}
                setDataResults={setDataResults}
            />

            {modalImage.show && (
                <ImageModal
                    show={modalImage.show}
                    onHide={() => setModalImage({ ...modalImage, show: false })}
                    imageUrl={modalImage.url}
                    title={modalImage.title}
                />
            )}
        </>
    )
}

export default MasterLogLeadTable